import React from 'react';
import cn from 'classnames';
import { useAppSelector } from '@app/hooks';
import { ModelLabel, ModelSizes, ModelVolume } from '@modules/models';
import { selectAppSettings } from '@modules/app';
import { ObjectModel } from '@types';
import { DetailsBox } from './details-box';

import styles from './product-details.module.scss';

interface Props {
    model: ObjectModel;
}

export const ProductDetails: React.FC<Props> = ({ model }) => {
    const settings = useAppSelector(selectAppSettings);
    const defaultConvertedUnits = settings.display_widget_units || model.units;

    return (
        <DetailsBox className={cn(styles.box, 'fade-in')}>
            <div className={'flex flex-col items-start'}>
                <ModelLabel className={styles.title} label={model?.title} />
                <ModelSizes
                    size={model.size}
                    units={model.units}
                    convertTo={defaultConvertedUnits}
                    className="justify-center"
                />
                <ModelVolume model={model} convertTo={defaultConvertedUnits} className="justify-center" />
            </div>
        </DetailsBox>
    );
};
